export const mentalHealthDiagnoses = [
  {
    code: 'F32.0',
    name: 'Mild Depressive Episode',
    classification: 'ICD-10',
    description:
      'A depressive episode characterized by persistent low mood, loss of interest, and other symptoms impacting daily functioning.',
  },
  {
    code: 'F32.1',
    name: 'Moderate Depressive Episode',
    classification: 'ICD-10',
    description:
      'A depressive episode with more pronounced symptoms leading to significant impairment in daily activities.',
  },
  {
    code: 'F33.1',
    name: 'Recurrent Depressive Disorder, Current Episode Moderate',
    classification: 'ICD-10',
    description:
      'Repeated episodes of depression with the current episode presenting moderate severity.',
  },
  {
    code: 'F41.1',
    name: 'Generalized Anxiety Disorder',
    classification: 'ICD-10',
    description:
      'Persistent, excessive worry and anxiety about various aspects of life.',
  },
  {
    code: 'F42',
    name: 'Obsessive-Compulsive Disorder',
    classification: 'ICD-10',
    description:
      'Characterized by the presence of obsessive thoughts and/or compulsive behaviors.',
  },
  {
    code: 'F31.2',
    name: 'Bipolar Affective Disorder, Current Episode Manic With Psychotic Symptoms',
    classification: 'ICD-10',
    description:
      'A mood disorder characterized by manic episodes with psychotic symptoms.',
  },
  {
    code: 'F43.1',
    name: 'Post-Traumatic Stress Disorder (PTSD)',
    classification: 'ICD-10',
    description:
      'A disorder that develops in some people who have experienced a shocking, scary, or dangerous event.',
  },
  {
    code: 'F50.0',
    name: 'Anorexia Nervosa',
    classification: 'ICD-10',
    description:
      'An eating disorder characterized by weight loss, difficulty maintaining an appropriate body weight, and distorted body image.',
  },
  {
    code: 'F50.2',
    name: 'Bulimia Nervosa',
    classification: 'ICD-10',
    description:
      'An eating disorder characterized by binge eating followed by purging.',
  },
  {
    code: 'F60.3',
    name: 'Borderline Personality Disorder',
    classification: 'ICD-10',
    description:
      'A disorder characterized by instability in interpersonal relationships, self-image, and emotions, and marked impulsivity.',
  },
  {
    code: '300.02',
    name: 'Generalized Anxiety Disorder',
    classification: 'DSM-5',
    description:
      'Excessive anxiety and worry occurring more days than not for at least six months, about a number of events or activities.',
  },
  {
    code: '296.23',
    name: 'Major Depressive Disorder, Single Episode, Severe Without Psychotic Features',
    classification: 'DSM-5',
    description:
      'A single, severe episode of depression that is not accompanied by psychotic features.',
  },
  {
    code: '301.22',
    name: 'Schizotypal Personality Disorder',
    classification: 'DSM-5',
    description:
      'A pattern of social and interpersonal deficits marked by acute discomfort with close relationships, cognitive distortions, and eccentric behavior.',
  },
  {
    code: '296.89',
    name: 'Bipolar II Disorder',
    classification: 'DSM-5',
    description:
      'A disorder characterized by episodes of hypomania and major depression.',
  },
  {
    code: '307.1',
    name: 'Anorexia Nervosa',
    classification: 'DSM-5',
    description:
      'An eating disorder characterized by an intense fear of gaining weight and a distorted body image.',
  },
  {
    code: '309.81',
    name: 'Post-Traumatic Stress Disorder (PTSD)',
    classification: 'DSM-5',
    description:
      'A disorder that develops following exposure to a traumatic event, causing flashbacks, nightmares, and severe anxiety.',
  },
  {
    code: '312.31',
    name: 'Oppositional Defiant Disorder',
    classification: 'DSM-5',
    description:
      'A disorder in children marked by defiant, disobedient, and hostile behaviors towards authority figures.',
  },
  {
    code: '300.01',
    name: 'Panic Disorder',
    classification: 'DSM-5',
    description:
      'Characterized by recurrent unexpected panic attacks, which are sudden periods of intense fear or discomfort.',
  },
  {
    code: '300.3',
    name: 'Obsessive-Compulsive Disorder',
    classification: 'DSM-5',
    description:
      'A disorder characterized by recurring, unwanted thoughts (obsessions) and/or repetitive behaviors (compulsions).',
  },
  {
    code: '295.90',
    name: 'Schizophrenia',
    classification: 'DSM-5',
    description:
      'A severe mental disorder characterized by distortions in thinking, perception, emotions, language, sense of self, and behavior.',
  },
  {
    code: '313.81',
    name: 'Separation Anxiety Disorder',
    classification: 'DSM-5',
    description:
      'Excessive fear or anxiety concerning separation from home or attachment figures.',
  },
  {
    code: '300.7',
    name: 'Body Dysmorphic Disorder',
    classification: 'DSM-5',
    description:
      'A mental disorder involving obsessive focus on a perceived flaw in appearance.',
  },
  {
    code: '300.4',
    name: 'Persistent Depressive Disorder (Dysthymia)',
    classification: 'DSM-5',
    description: 'A continuous, long-term form of depression.',
  },
  {
    code: '300.6',
    name: 'Depersonalization/Derealization Disorder',
    classification: 'DSM-5',
    description:
      'A disorder characterized by feeling detached from oneself or one’s surroundings.',
  },
  {
    code: '307.51',
    name: 'Insomnia Disorder',
    classification: 'DSM-5',
    description:
      'A disorder characterized by persistent difficulty falling asleep or staying asleep.',
  },
  {
    code: '300.3',
    name: 'Agoraphobia',
    classification: 'DSM-5',
    description:
      'An anxiety disorder characterized by intense fear of being in places or situations from which escape might be difficult.',
  },
  {
    code: '301.83',
    name: 'Borderline Personality Disorder',
    classification: 'DSM-5',
    description:
      'A disorder characterized by instability in interpersonal relationships, self-image, and emotions, and marked impulsivity.',
  },
];
